<script>
import Loader from '@/components/Loader.vue';
import BancoHoras from "@/components/EspacoDoColaborador/PontoExcecao/BancoHoras.vue";

export default {
  components: {BancoHoras, Loader},
  name: 'ponto-excecao',
  data() {
    return {
      loader: false,
    };
  },
};
</script>

<template>
  <div>
    <Loader :loader-primario="loader"></Loader>
    <v-container>
      <div class="card">
        <BancoHoras active-tab="tab-0" />
      </div>
    </v-container>
  </div>
</template>
